<template>
    <div>
        <DFormRow
            :label="__('customers.customers.iban')"
            :is-required="true"
            :error="errors.iban"
            :hint="__('customers.customers.payment_method_hint')"
        >
            <DInput
                id="iban"
                :model-value="iban"
                :placeholder="__('customers.customers.iban')"
                @update:modelValue="emit('update:iban', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.bic')"
            :is-required="false"
            :error="errors.bic"
            :hint="__('customers.customers.payment_method_hint')"
        >
            <DInput
                id="bic"
                :model-value="bic"
                :placeholder="__('customers.customers.bic')"
                @update:modelValue="emit('update:bic', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customers.account_owner')"
            :is-required="true"
            :error="errors.account_owner"
            :hint="__('customers.customers.payment_method_hint')"
        >
            <DInput
                id="account_owner"
                :model-value="accountOwner"
                :placeholder="__('customers.customers.account_owner')"
                maxlength="128"
                @update:modelValue="emit('update:accountOwner', $event)"
            />
        </DFormRow>
    </div>
</template>

<script setup>
defineProps({
    iban: {
        type: [String, Number],
        default: null
    },
    bic: {
        type: [String, Number],
        default: null
    },
    accountOwner: {
        type: [String, Number],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['update:iban', 'update:bic', 'update:accountOwner'])
</script>
